import React from "react";
import { Building, MapPin, Check, ArrowRight } from "lucide-react";

export const agencies = [
  { name: "Asnières (92)", city: "Asnières", id: "650adee7951dd697c7535e3e", department: "Hauts-de-Seine" },
  { name: "Toulouse (31)", city: "Toulouse", id: "654a3d82874a059df3f98653", department: "Haute-Garonne" },
  { name: "Brive (19)", city: "Brive", id: "6533fe25099978decf532a59", department: "Corrèze" },
];

export default function AgencyChoice({ currentCity, busy, onChoose }) {
  return <div className="space-y-3">
    {agencies.map(agency => {
      const current = currentCity === agency.city;
      return <button key={agency.id} type="button" disabled={Boolean(busy) || current} onClick={() => onChoose(agency)} className={`flex w-full items-center gap-4 rounded-xl border p-4 text-left disabled:cursor-default ${current ? "border-blue-200 bg-blue-50" : "border-slate-200 bg-white hover:border-blue-300 hover:bg-slate-50"}`}>
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-blue-100 text-blue-900"><Building size={22} /></span>
        <span className="min-w-0 flex-1"><span className="block font-semibold text-slate-900">{agency.name}</span><span className="mt-1 flex items-center gap-1 text-xs text-slate-500"><MapPin size={13} />{agency.department}</span></span>
        {current ? <span className="flex items-center gap-1 text-xs font-semibold text-blue-800"><Check size={16} />Actuelle</span> : busy === agency.id ? <span role="status" className="text-xs text-blue-800">Ouverture…</span> : <ArrowRight size={18} className="text-slate-400" />}
      </button>;
    })}
    <p className="pt-2 text-xs leading-relaxed text-slate-500">Votre dernière agence est mémorisée pour votre prochaine connexion.</p>
  </div>;
}
